import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { BadgeProps } from '@/components/ui/badge';
import type { CampaignStatus } from '../types';

const STATUS_VARIANT: Record<CampaignStatus, BadgeProps['variant']> = {
  draft: 'default',
  scheduled: 'info',
  sending: 'warning',
  sent: 'success',
  failed: 'destructive',
};

interface CampaignStatusBadgeProps {
  status: CampaignStatus;
  className?: string;
}

export default function CampaignStatusBadge({ status, className = '' }: CampaignStatusBadgeProps) {
  const { t } = useTranslation('campaigns');
  const label = t(`status.${status}`);
  return (
    <Badge
      variant={STATUS_VARIANT[status]}
      className={className}
      aria-label={t('status.badge', { label })}
    >
      {label}
    </Badge>
  );
}
